import { Link } from "wouter";
import { useAuth } from "../auth/AuthContext";
import { canSeeFleet } from "../auth/roleView";
import { FleetSwitcher } from "./FleetSwitcher";
import { ThemeToggle } from "./ThemeToggle";

export function TopBar() {
  const { session, logout } = useAuth();

  return (
    <header className="top-bar">
      <div className="top-bar__brand">
        <span className="top-bar__brand-mark" aria-hidden="true" />
        <span className="top-bar__brand-name">Comebye</span>
      </div>

      <div className="top-bar__spacer" />

      {/* A role with no fleet grants (billing_admin) has nothing to switch
          between — the fleet list is never fetched for it (FleetContext). */}
      {canSeeFleet(session?.role) && (
        <>
          <FleetSwitcher />
          <div className="top-bar__divider" aria-hidden="true" />
        </>
      )}

      <ThemeToggle />

      {session && (
        <div className="top-bar__user">
          {/* Account settings (profile + change password) is reachable by
           * every signed-in role, not just admins — unlike the Admin nav
           * group, so it lives here rather than in NavSidebar. */}
          <Link href="/account" className="top-bar__user-name">
            {session.displayName}
          </Link>
          <button type="button" className="top-bar__signout" onClick={() => void logout()}>
            Sign out
          </button>
        </div>
      )}
    </header>
  );
}
